import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';
import EmptyImage from '../../../assets/image/shared/chat_empty_profile_image.svg';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import ChatHeaderIcon from '../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import {useAuth} from '../../../context/authContext';
import AdvertisementTypeBS from '../myStore/elements/bottomSheetLists/AdvertisementTypeBS';
import {links} from './helper';

const MyAccountWrapper = () => {
  const {user, isSupplier, logout, supplierProfile} = useAuth();
  const [openAdBS, setOpenAdBS] = useState(false);
  const navigate = useNavigate();
  const [isExiting, setisExiting] = useState(false);
  const onEXitHandler = () => {
    setisExiting(false);
    logout();
  };

  const profile_image = isSupplier
    ? user?.profile?.supplier_profile?.profile_image
    : user?.profile?.farmer_profile?.profile_image;
  const name = isSupplier
    ? user?.profile?.supplier_profile?.name
    : user?.profile?.farmer_profile?.name;
  const phone_number = isSupplier
    ? user?.profile?.supplier_profile?.phone_number
    : user?.profile?.farmer_profile?.cell_phone;
  const id = isSupplier
    ? user?.profile?.supplier_profile?.guid
    : user?.profile?.farmer_profile?.guid;

  return (
    <>
      <div className="relative flex flex-col justify-between w-full h-full">
        <div className="flex flex-col w-full h-full">
          <CustomHeader
            title="حساب من"
            onClick={() => navigate('/home')}
            preIcon="icon-nameArrow---Right"
            isActiveRightIcon
            postComponent={() => (
              <div className="flex gap-3 ">
                <NotificationHeaderIcon />
                <ChatHeaderIcon />
              </div>
            )}
          />
          <div className="flex flex-col justify-between h-full">
            <div className="flex flex-col justify-between w-full gap-4 p-3 items">
              <div
                className="w-full justify-between flex h-[88px] rounded-lg bg-gray-50 px-2"
                onClick={() => navigate(`/edit/my-account/${id}`)}
              >
                <div className="flex items-center pl-3 h-[88px] gap-3">
                  <img
                    width={64}
                    height={64}
                    className="rounded-full object-cover w-[64px] h-[64px]"
                    src={profile_image || EmptyImage}
                    alt={name || 'empty-profile'}
                  />
                  <div className="flex flex-col gap-2 text-md font-Regular">
                    <span className="text-gray-950">{name} </span>
                    <span className="text-gray-800">{phone_number}</span>
                  </div>
                </div>
                <button>
                  <SpanIcon className="icon-nameArrow---Left-2 text-xxl" />
                </button>
              </div>

              <div className="flex flex-col w-full h-full">
                {links.map((item, index) => (
                  <React.Fragment key={index}>
                    <div
                      onClick={() => {
                        if (item.route === '/my-ads') {
                          setOpenAdBS(true);
                        } else {
                          navigate(item.route);
                        }
                      }}
                      className="flex items-center justify-between w-full px-2 text-inherit"
                    >
                      <div className="flex items-center gap-2 text-gray-900 text-md font-Regular">
                        <SpanIcon
                          className={classNames('text-xxl', item.icon)}
                        />
                        <div>{item.label}</div>
                      </div>
                      <button>
                        <SpanIcon className="icon-nameArrow---Left-2 text-xxl" />
                      </button>
                    </div>
                    <br className="" />
                  </React.Fragment>
                ))}
              </div>
            </div>
            <button
              className="flex items-center gap-1 px-3 py-3 text-red-600 text-md font-Regular"
              onClick={() => setisExiting(true)}
            >
              <SpanIcon className="text-xl icon-nameLogout" />
              <span>خروج از حساب کاربری</span>
            </button>
          </div>
          <BottomSheet
            onDismiss={() => {
              setisExiting(false);
            }}
            open={isExiting}
            blocking={true}
            className="transition ease-in-out delay-250 "
          >
            <div className="flex flex-col w-full gap-3 p-3">
              <div className="flex justify-between w-full">
                <p>خروج از حساب</p>
                <SpanIcon
                  className="text-xl icon-nameClose-remove"
                  onClick={() => setisExiting(false)}
                />
              </div>
              <p>آیا می‌خواید از حساب کاربری خود خارج شوید؟</p>
              <div className="flex items-center justify-between w-full gap-2 text-md font-Medium">
                <button
                  className="w-[70%] bg-red-500 h-[48px] text-white rounded-[8px]"
                  onClick={() => onEXitHandler()}
                >
                  بله، خروج از حساب
                </button>
                <button
                  className="w-[30%] text-farm-shop-500 h-[48px] border border-farm-shop-500 rounded-[8px]"
                  onClick={() => setisExiting(false)}
                >
                  خیر
                </button>
              </div>
            </div>
          </BottomSheet>
        </div>
        <MainFooter />
      </div>
      <AdvertisementTypeBS
        open={openAdBS}
        setIsOpen={setOpenAdBS}
        hasStore={!!user?.profile?.supplier_profile?.store?.guid}
      />
    </>
  );
};

export default MyAccountWrapper;
